export default __webpack_public_path__ + "static/pagination-right-arrow-mobile-1a97687b7a009650e3806f30726437bf.svg";